import Flex from 'frontend/commons/Flex'
import { PACKAGE_CARD_TABS_KEYS } from 'frontend/constants'
import { usePackageCard } from 'frontend/contexts/PackageCardContext'
import FlightsInfo from '../FlightsInfo'
import HotelsInfo from '../HotelsInfo'
import InfoHeader from './components/InfoHeader'
import LoadSpinner from 'frontend/commons/spinner'
import { useMemo, useRef } from 'react'

const { HOTELS, FLIGHTS } = PACKAGE_CARD_TABS_KEYS

const DynamicContent = () => {
  const containerRef = useRef(null)
  const {
    selectedTab,
    displayInfo,
    departureDatesIsLoading,
    packageConfigurationsIsLoading,
    packageConfigurationsIsFetching,
  } = usePackageCard()

  const tabs = useMemo(() => ({
    [FLIGHTS]: <FlightsInfo />,
    [HOTELS]: <HotelsInfo containerRef={containerRef} />,
  }), [containerRef])

  return displayInfo ? (
    <div ref={containerRef} className="flex flex-col package-card__dynamic-content">
      <InfoHeader tabs={Object.keys(tabs)} />
      <Flex vertical className="package-card__dynamic-content__wrapper">
        {departureDatesIsLoading ||
        packageConfigurationsIsLoading ||
        packageConfigurationsIsFetching ? (
          <LoadSpinner style={{ marginTop: 20, marginBottom: 20 }} />
        ) : (
          tabs[selectedTab]
        )}
      </Flex>
    </div>
  ) : null
}

export default DynamicContent
